import { combineReducers } from "redux";
import navigationReducer from "./navigation/navigationReducer";
import commonReducer from "./common/commonReducer";
import { address } from "../designs/v1/pages/Address/redux/reducer";
import { income } from "../designs/v1/pages/IncomeProof/redux/reducer";
import { review } from "../designs/v1/pages/Review/redux/reducer";
import { visual } from "../designs/v1/pages/VisualVerification/redux/reducer";
import themeReducer from "../designs/v1/redux/reducer";
import jointholderReducer from "./jointholder/jointholderReducer";
const rootReducer = combineReducers({
  navigation: navigationReducer,
  common: commonReducer,
  address,
  income,
  review,
  visual,
  theme: themeReducer,
  jointholder: jointholderReducer
});

export default rootReducer;
